import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-545d2f34")

_pushScopeId("data-v-545d2f34")
const _hoisted_1 = {
  class: "hidden",
  ref: "textRef"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_icon_button = _resolveComponent("icon-button")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_icon_button, {
      icon: "copy",
      state: "normal",
      onClick: _ctx.onCopy
    }, null, 8, ["onClick"]),
    _createVNode("textarea", _hoisted_1, null, 512)
  ]))
})